import * as React from 'react';
import { Button } from 'reactstrap';
import { IButtonClickable } from './types';

const EditIconButton: React.FC<IButtonClickable & { disabled?: boolean }> = ({ disabled = false, ...props }) => {

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    if (disabled) return;
    props.onClick(event);
  };
  return (
    <Button color="info" onClick={handleClick} disabled={disabled}><i title="Edit" className="fa fa-2x fa-pencil" /></Button>
  );

};

export default EditIconButton;
